import Address from "@/models/questions/address";

export interface AnswerCompanyOwner extends CompanyOwner {}

export interface CompanyOwner {
  companyName: string;
  dateOfIncorporation: string;
  countryOfIncorporation: string;
  businessRegistrationNumber: string;
  organizationalForm: string;
  industry: string;
  website: string;
  address: Address;
  knownBeneficialOwner: string;
  subjectToSanctions: string;
}

export function createEmptyCompanyOwner(): CompanyOwner {
  return {
    companyName: "",
    businessRegistrationNumber: "",
    countryOfIncorporation: "",
    dateOfIncorporation: "",
    industry: "",
    website: "",
    organizationalForm: "",
    address: new Address(),
    knownBeneficialOwner: "",
    subjectToSanctions: "",
  };
}
